import { createSelector } from 'reselect';

// Utils
import {
    createElementUserPermissionsSelector,
    currentBoardUserPermissionsSelector,
} from '../../../utils/permissions/elementPermissionsSelector';

import { getCurrentUser, getCurrentUserRootBoardId } from '../../../user/currentUserSelector';
import { getClosestPermissionIdForElementIdSelector } from '../../../utils/permissions/permissionsSelector';

const createBreadcrumbSelector = () =>
    createSelector(
        (state) => state.get('elements'),
        (state, props) => props.elementId,
        getCurrentUserRootBoardId,
        getCurrentUser,
        (state, props) => props.currentBoardId,
        (state, props) => props.isRoot,
        createElementUserPermissionsSelector(),
        currentBoardUserPermissionsSelector,
        getClosestPermissionIdForElementIdSelector(),
        (
            elements,
            elementId,
            rootBoardId,
            currentUser,
            currentBoardId,
            isRoot,
            breadcrumbPermissions,
            currentBoardPermissions,
            closestPermissionId,
        ) => ({
            element: elements.get(elementId),
            isRoot: elementId === rootBoardId || isRoot,
            isCurrentBoard: elementId === currentBoardId,
            currentUser,
            // This supports the hover navigate functionality
            // dropPermitted: canDrop,
            elementPermissions: breadcrumbPermissions,
            permissions: currentBoardPermissions,
            closestPermissionId,
        }),
    );

export default createBreadcrumbSelector;
